
import { useEffect, useRef, useState } from 'react';
import SelectWithIcon from '~/components/SelectWithIcon.jsx';

const SectionPicker = ({ value, onChange, options, className, slim }) => {
    const bgRef = useRef(null);
    const containerRef = useRef();
    const [isMobile, setIsMobile] = useState(false);
    const hasInitialized = useRef(false);

    useEffect(() => {
        // Use shorter delay for initial load, normal delay for subsequent changes
        const delay = hasInitialized.current ? 100 : 0;
        
        setTimeout(() => {
            if (!bgRef.current || !containerRef.current) {
                return;
            }

            bgRef.current.style.height =
                containerRef.current.offsetHeight - 4 * 2 + 'px';
            const width =
                containerRef.current.getElementsByTagName('div')[0].offsetWidth;
            bgRef.current.style.width = width + 'px';

            if (width <= 33) {
                setTimeout(() => {
                    const els =
                        containerRef.current?.getElementsByTagName('div');

                    if (!els || !els[0]) {
                        return;
                    }

                    const width = els[0].offsetWidth;
                    if (bgRef?.current?.style) {
                        bgRef.current.style.width = width + 'px';
                    }
                }, 1500);
            }

            const selectedTab =
                containerRef.current.getElementsByClassName('selected-tab')[0];
            if (selectedTab) {
                selectTarget(selectedTab);
            }

            // Enable transitions and show background AFTER positioning
            if (!hasInitialized.current) {
                hasInitialized.current = true;
                if (bgRef.current) {
                    bgRef.current.style.opacity = '1';
                    // Add transition class after making visible
                    requestAnimationFrame(() => {
                        if (bgRef.current) {
                            bgRef.current.classList.add('transition-all');
                        }
                    });
                }
            }
        }, delay);  // Use the conditional delay here
    }, [value, options]);

    useEffect(() => {
        if (containerRef.current) {
            const rect = containerRef.current.getBoundingClientRect();
            if (rect.width + 50 > window.innerWidth) {
                setIsMobile(true);
            }
        }
    }, []);

    function selectTarget(target) {
        if (!bgRef.current) {
            return;
        }

        bgRef.current.style.width = target.offsetWidth + 'px';
        bgRef.current.style.left = target.offsetLeft + 'px';
    }

    function onClick(ev, value) {
        selectTarget(ev.target);
        onChange(value);
    }

    if (isMobile) {
        return (
            <div ref={containerRef} className={className}>
                <SelectWithIcon
                    value={value}
                    onChange={onChange}
                    options={options.map(o => ({ ...o, name: o.label }))}
                />
            </div>
        );
    }

    return (
        <div className="flex">
            <div
                ref={containerRef}
                className={`z-0 bg-gray-200 rounded-full p-1 relative flex items-center ${className}`}
            >
                <span
                    ref={bgRef}
                    className="bg-white block rounded-full top-1 h-[82%] absolute w-[108px]"
                    style={{ opacity: hasInitialized.current ? 1 : 0 }}
                />

                {options.map(opt => (
                    <div
                        key={opt.value}
                        className={`section-picker-option ${slim ? 'text-sm px-4 py-1' : 'text-base px-6 py-2'} z-10 font-semibold cursor-pointer uppercase hover:text-gray-700 ${opt.value === value ? 'text-gray-700 selected-tab' : 'text-gray-500'}`}
                        onClick={ev => onClick(ev, opt.value)}
                    >
                        {opt.label}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SectionPicker;
